import TableView from "@/common/components/TableViewNew/TableView";
import { Grid, Button } from "@mui/material";
import React from "react";
import { columns, reportFileName } from "./constants/constants";
import { useNavigate } from 'react-router-dom';
import navs from "@/from-theme/routes/constants/nav";
import { PlusOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import useOnActions from "./hooks/useOnActions";
import AlertDialog from "@/common/components/alert-dialog/alert-dialog";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { isUserHasAccess } from "@/from-theme/utils/route-guard/helpers/helpers";
import useAuth from "@/from-theme/hooks/useAuth";
import VerifyAccess from "@/common/components/verify-access/verify-access";
import useSchemeNonEligibleApproval from "./hooks/useSchemeNonEligibleApproval";

const { schemeNonEligibleApprovalMasterKey } = requestedMenuAll;
const { createKey, updateKey, deleteKey } = requestedFeaturesAll;

const SchemeNonEligibleApproval = () => {
  const { schemesMasterData, schemesMasterStatus, schemesMasterErrMsg }
    = useSchemeNonEligibleApproval();


  const { userData } = useAuth();
  const entitlement = userData?.entitlement || {};

  const isUpdateDeleteAccess = isUserHasAccess(schemeNonEligibleApprovalMasterKey, updateKey, entitlement)
    || isUserHasAccess(schemeNonEligibleApprovalMasterKey, deleteKey, entitlement);

  const {
    onRowEdit,
    onRowDelete,
    deleteCompetitorMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert
  } = useOnActions();

  const navigate = useNavigate();
  const actionButton = (
    <VerifyAccess requestedMenu={schemeNonEligibleApprovalMasterKey} requestedFeature={createKey}>
      <Button
        variant="contained"
        startIcon={<PlusOutlined />}
        onClick={() => navigate(navs.schemeNonEligibleApprovalMasterKey)}
      ><FormattedMessage id="add-competitor" />
      </Button>
    </VerifyAccess>
  )
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TableView
          data={schemesMasterData}
          columns={columns({
            onRowEdit, onRowDelete, deleteCompetitorMasterStatus,
            isUpdateDeleteAccess
          })}
          reportFileName={reportFileName}
          apiStatus={schemesMasterStatus}
          apiErrorMsg={schemesMasterErrMsg}
          stringInExport={["activeStatus"]}
        />
        {isAlertDialog && (
          <AlertDialog onCloseAlert={onCloseAlert} onAgreeAlert={onAgreeAlert} />
        )}
      </Grid>
    </Grid>
  );
};

export default SchemeNonEligibleApproval; 